import Button from '@insided/control/uikit/Button'
import { performBulkActionForTopics } from '../../utils'
// eslint-disable-next-line import/no-internal-modules
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

const TrashTopic = ({ performBulkAction }: BulkActionComponentProps) => (
  <Button
    title={
      <div>
        <Icon icon='trash' width={16} height={16} />
        Trash
      </div>
    }
    size='medium'
    variant='warning'
    className='qa-trash-topic'
    onClick={() =>
      performBulkAction({
        onClick: async (topics: any) => await performBulkActionForTopics(topics, 'trash'),
        successMessage: 'Item(s) successfully trashed'
      })}
  />
)

export default TrashTopic
